module.exports = __webpack_public_path__ + "static/media/pending_purchase.b3610d62.svg";